import { motion } from "framer-motion";
import { MANIFESTO } from "../../data/menu";

const reveal = {
  hidden: { opacity: 0, y: 40 },
  show: (i) => ({
    opacity: 1,
    y: 0,
    transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1], delay: i * 0.1 },
  }),
};

export const Manifesto = () => {
  return (
    <section
      id="why"
      data-testid="manifesto-section"
      className="mx-auto max-w-[1600px] px-5 md:px-10 py-24 md:py-40"
    >
      <motion.h2
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-100px" }}
        transition={{ duration: 0.7, ease: [0.16, 1, 0.3, 1] }}
        className="font-display uppercase leading-none tracking-tight text-5xl md:text-8xl mb-16 md:mb-24"
      >
        Why <span className="text-[#e63946]">Cater</span> With Us
      </motion.h2>

      <div className="border-t border-white/10">
        {MANIFESTO.map((m, i) => (
          <motion.div
            key={m.n}
            custom={i}
            variants={reveal}
            initial="hidden"
            whileInView="show"
            viewport={{ once: true, margin: "-80px" }}
            className="group grid grid-cols-1 md:grid-cols-12 gap-4 md:gap-10 items-start border-b border-white/10 py-10 md:py-14 transition-colors duration-500 hover:bg-white/[0.02]"
          >
            <span className="md:col-span-2 font-accent text-6xl md:text-8xl text-[#ffb703] leading-none">
              {m.n}
            </span>
            <h3 className="md:col-span-4 font-display uppercase text-3xl md:text-5xl leading-none tracking-tight text-white group-hover:text-[#e63946] transition-colors duration-300">
              {m.title}
            </h3>
            <p className="md:col-span-6 font-body text-base md:text-xl text-[#a8a8a8] leading-relaxed md:pt-2">
              {m.body}
            </p>
          </motion.div>
        ))}
      </div>
    </section>
  );
};
